import { render, staticRenderFns } from "./PageDayCare.vue?vue&type=template&id=30d31cb2&"
import script from "./PageDayCare.vue?vue&type=script&lang=js&"
export * from "./PageDayCare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports